import React, { useState } from "react";

export default function useForm(
  initialValue,
  validateOnChange = false,
  validate
) {
  const [values, setValues] = useState(initialValue);
  const [errors, setErrors] = useState({});

  const handleInputChange = (e) => {
    const { name, value, type } = e.target;
    setValues({
      ...values,
      [name]: type === "number" ? +value : value,
    });
    if (validateOnChange) validate({ [name]: value });
  };

  const resetForm = (e) => {
    setValues(initialValue);
    setErrors({});
  };

  return {
    values,
    setValues,
    errors,
    setErrors,
    handleInputChange,
    resetForm,
  };
}

export function Form(props) {
  const { children, ...other } = props;

  return (
    <form autoComplete="off" {...other}>
      {children}
    </form>
  );
}
